module.exports = __webpack_public_path__ + "static/media/dog-leashed.ea9cc5c1.svg";